<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line--right" *ngIf="!showSearch">
        <div class="ir-btn th-btn-modal" (click)="updateShowSearch()">
          <i class="material-icons">search</i>
        </div>
      </div>
      <div class="ir-line" *ngIf="!showSearch">
        <div class="ir-line-content">
          <span>{{ 'inspections.create-inspection' | translate }}</span>
        </div>
      </div>
      <div class="ir-line th-header-search" *ngIf="showSearch">
        <div class="ir-line--left">
          <div class="ir-btn th-btn-unactive">
            <i class="material-icons">search</i>
          </div>
        </div>
        <div class="ir-line--right">
          <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
            <i class="material-icons">close</i>
          </div>
        </div>
        <div class="ir-line-content">
          <input
            autoFocus
            type="search"
            name="Search"
            placeholder="{{ 'common.placeholders.search' | translate }}"
            [(ngModel)]="query"
            focus="showSearch"
          />
        </div>
      </div>
    </div>

    <div class="ir-modal--body has-footer">
      <div class="ir-content--modal th-content">
        <div class="ir-item-line th-filter-modal">
          <div (click)="setOrderBy('Name')" class="ir-item-cell s4 clickable">
            <span>
              <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
              <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
              {{ 'common.name' | translate }}
            </span>
          </div>
          <div (click)="setOrderBy('Descrption')" class="ir-item-cell s6 clickable">
            <span>
              <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
              <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
              {{ 'common.description' | translate }}
            </span>
          </div>
        </div>
        <div class="ir-content-flow has-filter th-content-flow--dark has-footer">
          <div *ngIf="models">
            <div
              class="ir-item-line th-model indent clickable"
              [ngClass]="model.selected ? 'selected' : ''"
              *ngFor="let model of models | orderBy: orderByFieldName:direction | searchBy: query"
              (click)="selectModel(model)"
            >
              <div class="ir-item-cell s4">
                <div class="ir-item-selector">
                  <i class="material-icons">content_paste</i>
                </div>
                <span>{{ model.name }}</span>
              </div>
              <div class="ir-item-cell s6">
                <span *ngIf="model.description">{{ model.description }}</span>
                <span *ngIf="!model.description">{{ 'common.no-description' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- End content flow -->
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            (click)="save()"
            *ngIf="selectedModel && !createProcessing"
          >
            <span>{{ 'inspections.create-from' | translate }} &laquo; {{ selectedModel?.name }} &raquo;</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="createProcessing"
          >
            <span>{{ 'inspections.processing' | translate }} ...</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="!selectedModel && !createProcessing"
          >
            <span>{{ 'inspections.select-model' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
